// Per-page metadata for a client-rendered SPA.
//
// The app is served from https://chisp.ai under the /portal basename (see
// src/index.js), so canonical and og:url are built from that same prefix.

export const SITE_NAME = "Chisp";
export const ORIGIN = "https://chisp.ai";
export const BASENAME = "/portal";
export const OG_IMAGE = `${ORIGIN}/og-image.png`;

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Set the document title, description, canonical URL and social card tags.
 *
 * @param {string} title       Page title, without the site name suffix.
 * @param {string} description One or two sentences; used for search results
 *                             and for link previews on LinkedIn.
 * @param {string} path        Route path, e.g. "/consulting". Use "/" for home.
 */
export function setPageMeta({ title, description, path = "/" }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${ORIGIN}${BASENAME}${path === "/" ? "/" : path}`;

  document.title = fullTitle;

  upsertMeta("name", "description", description);
  upsertLink("canonical", url);

  upsertMeta("property", "og:site_name", SITE_NAME);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:title", fullTitle);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:image", OG_IMAGE);

  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", fullTitle);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", OG_IMAGE);
}
